// Resolves large static images to a Cloudflare R2 CDN (zero egress fee) when
// VUE_APP_CDN_URL is set, falling back to the locally-bundled copy otherwise.
//
// Usage:
//   import { cdnImage } from '@/utils/cdn'
//   cdnImage('kaiju/first.jpg')
//
// The `path` is relative to the images root (src/assets/images/ locally, and
// the bucket root on R2). Keep the same folder/file names in R2 so only the
// host prefix changes.

const CDN_BASE = (process.env.VUE_APP_CDN_URL || '').replace(/\/+$/, '')

// Eagerly required local fallbacks. require.context lets webpack resolve a
// dynamic path to the bundled asset when no CDN is configured (e.g. local dev).
const localImages = require.context(
  '@/assets/images',
  true,
  /\.(png|jpe?g|gif|svg|webp)$/
)

export function cdnImage(path) {
  const clean = String(path).replace(/^\/+/, '')
  if (CDN_BASE) return `${CDN_BASE}/${clean}`
  // Fall back to the bundled asset.
  return localImages(`./${clean}`)
}

export default cdnImage
